<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.user_new.title')"
            back
        />
        <v-row>
            <v-col cols="12">
                <UserForm
                    :user="user"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import UserForm from '@/components/users/Form/UserForm';
import UserProxy from '@/proxies/UserProxy';
import { StandBy, SuccessSnackbar } from '@/app-events.js';

export default {
    name: 'UserNew',
    components: {
        PageHeader,
        UserForm,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.admin.title'),
                    disabled: true,
                    href: '/admin',
                },
                {
                    text: this.$t('page.user.title'),
                    exact: true,
                    to: { name: 'admin_users' },
                },
                {
                    text: this.$t('general.new'),
                    disabled: true,
                },
            ],
            user: {
                email: '',
                roles: [],
                coach: {
                    firstname: '',
                    lastname: '',
                    phone: '',
                },
            },
            rawData: {
                email: '',
                roles: [],
                coach: {
                    firstname: '',
                    lastname: '',
                    phone: '',
                },
            },
        };
    },
    methods: {
        routerBack() {
            this.$router.push({ name: 'admin_users' });
        },
        resetObject() {
            this.user = JSON.parse(JSON.stringify(this.rawData));
            this.resetErrors();
        },
        saveObject() {
            if (JSON.stringify(this.user) === JSON.stringify(this.rawData)) {
                return;
            }
            this.$eventBus.dispatch(new StandBy(true));
            const formData = {
                user: JSON.parse(JSON.stringify(this.user)),
            };
            new UserProxy().new(formData).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('user.actions.created')));
                this.$router.push({ name: 'admin_user_detail', params: { id: data.data.id } });
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        }
    },
};
</script>
